var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapDisable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b5b5b5;}.b{fill:rgba(255,255,255,0);}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(0 0)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30,
    height: 30,
    rx: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.051 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.073,17c-.117,0-.233-.108-.365-.342-.631-1.124-1.893-3.282-1.9-3.3-.333-.536-.7-1.066-1.086-1.626l0-.005A17.881,17.881,0,0,1,.357,7.569a5.756,5.756,0,0,1,.32-4.716A5.043,5.043,0,0,1,2.845.732,6.574,6.574,0,0,1,5.893,0a5.752,5.752,0,0,1,5.063,2.707,5.981,5.981,0,0,1,.665,5.015,16.06,16.06,0,0,1-2.356,4.263c-.329.477-.638.923-.926,1.375-.008.013-1.27,2.208-1.887,3.287C6.316,16.885,6.192,17,6.073,17ZM5.949,3.4a2.338,2.338,0,1,0,2.34,2.335A2.338,2.338,0,0,0,5.949,3.4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDisable);
export default __webpack_public_path__ + "static/media/map_disable.831cc5aecdd56e33559f742c9bac11e8.svg";
export { ForwardRef as ReactComponent };